<template>
  <div :class="$style.page">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="发票管理" name="first">
        <template v-if="activeName === 'first'">
          <ReceiptManage />
        </template>
      </el-tab-pane>
      <el-tab-pane label="发票申请" name="second">
        <template v-if="activeName === 'second'">
          <ReceiptApply />
        </template>
      </el-tab-pane>

      <el-tab-pane label="发票信息" name="third">
        <template v-if="activeName === 'third'">
          <ReceiptInfo />
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReceiptManage from "./receipt/ReceiptManage.vue";
import ReceiptApply from "./receipt/ReceiptApply.vue";
import ReceiptInfo from "./receipt/ReceiptInfo.vue";

export default {
  name: "Receipt",
  components: {
    ReceiptManage,
    ReceiptApply,
    ReceiptInfo,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  watch: {
    $route({ query }) {
      this.activeName = query.activeName || "first";
    },
  },
  methods: {
    handleClick() {
      const query =
        this.activeName === "first" ? {} : { activeName: this.activeName };
      this.$router.push({ path: "/user/receipt", query });
    },
  },
  created() {
    const { query } = this.$route;
    this.activeName = query.activeName || "first";
  },
};
</script>

<style lang="scss" module scoped>
.page {
  :global {
    ::v-deep .el-tabs {
      .el-tabs__content {
        min-height: 300px;
        overflow: unset;
      }
    }
  }
}
</style>
